module.exports = __webpack_public_path__ + "img/ring_r_i_0_0@2x.cc13705b.png";